export const typography = {
  h1: {
    fontFamily: 'var(--font-family--commissioner)',
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: '0.1px',
    lineHeight: 1.1,
    textTransform: 'uppercase',
    fontSize: '4.77rem'
  },
  h2: {
    fontFamily: 'var(--font-family--commissioner)',
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: '0.1px',
    lineHeight: 1.16,
    textTransform: 'uppercase',
    fontSize: '3.33rem'
  },
  h3: {
    fontFamily: 'var(--font-family--commissioner)',
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: '0.1px',
    lineHeight: 1.16,
    textTransform: 'uppercase',
    fontSize: '1.77rem'
  },
  h4: {
    fontFamily: 'var(--font-family--commissioner)',
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: '0.1px',
    lineHeight: 1.33,
    textTransform: 'uppercase',
    fontSize: '1.33rem'
  },
  h5: {
    fontFamily: 'var(--font-family--commissioner)',
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: '0.1px',
    lineHeight: 1.66,
    textTransform: 'uppercase',
    fontSize: '1.2rem'
  },
  h6: {
    fontFamily: 'var(--font-family--commissioner)',
    fontStyle: 'normal',
    fontWeight: 800,
    letterSpacing: '0.1px',
    lineHeight: 1,
    textTransform: 'uppercase',
    fontSize: '1rem'
  }
} as const

export type HeadingKey = keyof typeof typography
